import { pathBuilder } from 'config/paths/index';

export const root = '/admin/files';
export default pathBuilder(root);
